import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "sms", "whatsapp", "smsContent", "whatsappBody", "whatsappImage"]

  connect() {
    this.changeChannel()
  }

  changeChannel() {
    const channel = this.element.querySelector('input[name="view_template[tipo]"]:checked')?.value

    this.emailTarget.classList.toggle("d-none", channel !== "email")
    this.smsTarget.classList.toggle("d-none", channel !== "sms")
    this.whatsappTarget.classList.toggle("d-none", channel !== "whatsapp")

    this.emailTarget.querySelectorAll("input, textarea, select").forEach((input) => {
      input.disabled = channel !== "email"
    })
    this.smsContentTarget.disabled = channel !== "sms"
    this.whatsappBodyTarget.disabled = channel !== "whatsapp"
    this.whatsappImageTarget.disabled = channel !== "whatsapp"
  }
}
